import {
  Button,
  CircularProgress,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import { useContext, useState } from 'react'
import { CustomModalContext } from 'common/contexts/CustomModalContext'
import { InvoicePurchaseHelper } from '../helpers/InvoicePurchaseHelper'
import { enqueueSnackbar } from 'notistack'
import InvoicePurchaseSkeleton from './skeleton/InvoicePurchaseSkeleton'

/**
 * @module FetchOrdersDropDown
 */

/**
 *
 * @param {Object} props
 * @param {function} props.setPurchase
 * @param {function} props.clearPurchase
 * @param {Object} props.selectedPurchase
 * @param {Array} props.selectedPurchase
 * @param {boolean} props.loading
 * @returns {JSX.Element}
 */

const InvoicePurchaseSelector = ({
  setPurchase = () => undefined,
  selectedPurchase,
  clearPurchase,
  purchaseList,
  loading,
}) => {
  const { handleModal } = useContext(CustomModalContext)
  const [selectedRow, setSelectedRow] = useState(
    selectedPurchase.id_entrada + selectedPurchase.id_detalle,
  )
  const [fileloding, setFileLoading] = useState(false)

  const downloadFileHandler = (event, row) => {
    const { download_file, file_name } = row
    event.stopPropagation()
    setFileLoading(true)
    const [, file_url] = download_file.split('/api/v1')
    if (!file_url) {
      enqueueSnackbar('Ruta de archivo no válida', { variant: 'error' })
      return
    }
    InvoicePurchaseHelper.fetchFile(file_url)
      .then((res) => {
        if (!res.data) {
          enqueueSnackbar('Archivo no encontrado', { variant: 'error' })
          return
        }
        const decodedData = atob(res.data)
        const blob = new Blob([decodedData], { type: 'application/xml' })
        const url = window.URL.createObjectURL(blob)
        const downloadLink = document.createElement('a')
        downloadLink.setAttribute('href', url)
        downloadLink.setAttribute('download', file_name)
        downloadLink.click()
        downloadLink.remove()
      })
      .catch((err) => {
        enqueueSnackbar('Archivo no encontrado', { variant: 'error' })
      })
      .finally(() => {
        setFileLoading(false)
      })
  }

  const handleClose = () => {
    handleModal({ enabled: false })
  }

  const handleClear = () => {
    setSelectedRow(null)
    clearPurchase({})
  }

  return (
    <>
      {loading ? (
        <InvoicePurchaseSkeleton rows={3} columns={4} />
      ) : (
        <Paper sx={{ bgcolor: '#efefef', zIndex: 10000 }}>
          <Stack direction={'row'} justifyContent={'flex-end'} spacing={2}>
            <Button onClick={handleClear}>Vaciar</Button>
            <Button onClick={handleClose}>Cerrar</Button>
          </Stack>
          <TableContainer
            component={Paper}
            sx={{
              maxHeight: '70vh',
            }}
          >
            <Table sx={{ minWidth: 650 }} stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ p: '10px 16px' }} align="left">
                    Fecha
                  </TableCell>
                  <TableCell sx={{ p: '10px 16px' }} align="right">
                    Nombre
                  </TableCell>
                  <TableCell sx={{ p: '10px 16px' }} align="right">
                    Número de factura
                  </TableCell>
                  <TableCell sx={{ p: '10px 16px' }} align="right">
                    Descargar
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {!loading &&
                  purchaseList?.map((row) => (
                    <TableRow
                      onClick={() => {
                        setSelectedRow(row.id_entrada + row.id_detalle)
                        setPurchase({
                          id_entrada: row.id_entrada,
                          id_detalle: row.id_detalle,
                          file_name: row.file_name,
                        })
                      }}
                      key={row.id_entrada + row.id_detalle}
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      sx={{
                        cursor: 'pointer',
                        bgcolor:
                          selectedRow === row.id_entrada + row.id_detalle ? '#d9f0f4' : 'inherit',
                        '&:hover': {
                          bgcolor:
                            selectedRow === row.id_entrada + row.id_detalle
                              ? '#e8f1f3 !important'
                              : 'inherit',
                        },
                      }}
                    >
                      <TableCell align="left" sx={{ padding: '9px 16px' }}>
                        {row.invoice_date}
                      </TableCell>
                      <TableCell align="right" sx={{ padding: '9px 16px' }}>
                        {row.file_name}
                      </TableCell>
                      <TableCell align="right" sx={{ padding: '9px 16px' }}>
                        {row.invoice_number}
                      </TableCell>
                      <TableCell align="right" sx={{ padding: '9px 16px' }}>
                        <Button
                          onClick={(e) => downloadFileHandler(e, row)}
                          sx={{ padding: '1px 15px' }}
                          disabled={fileloding}
                        >
                          {fileloding && (
                            <CircularProgress size={20} sx={{ position: 'absolute' }} />
                          )}
                          descargar
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      )}
    </>
  )
}

export default InvoicePurchaseSelector
